import {post, get} from '@/utils/apiBase.js'
//获取补充资质列表
const getSupplementMaterial = option => {
    return get('/apis/product/get_supplement_material', option)
}
//保存补充资质接口
const saveSupplementMaterial = option => {
    return post('/apis/product/save_supplement_material', option)
}
export default {
    getSupplementMaterial,
    saveSupplementMaterial
};